import React from 'react';
import {
    Dialog,
    Box,
    Typography,
    IconButton,
    Divider,
    Chip,
} from '@mui/material';
import { useSelector } from "react-redux";
import { get, map, find } from "lodash";
import CloseIcon from '@mui/icons-material/Close';
import Alert from "../../../components/form/Alert";
import Table from "../../../components/form/TableDetail";
import { useState } from 'react';

const LogsModal = ({ __, open, close }) => {
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const log        = useSelector((state) => state.config.log);
    const logActions = __(`logActions`, { returnObjects: true });

    const closeAlert = () => setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });

    const headTable = [
        { key: "docId",  label: __(`table.cols.docId`),  align: "center" },
        { key: "maeId",  label: __(`table.cols.maeId`),  align: "center" },
        { key: "action", label: __(`table.cols.action`), align: "center" },
        { key: "date",   label: __(`table.cols.date`),   align: "center" },
        { key: "screen", label: __(`table.cols.screen`), align: "center" },
        { key: "users",  label: __(`table.cols.users`),  align: "center" },
    ];

    const dataTable = map(get(log, "data.data", []), (row) => {
        const actionItem = find(logActions, ({ value }) => value === get(row, "action"));
        return {
            ...row,
            action: (
                <Chip
                    label={get(actionItem, "label", get(row, "action"))}
                    sx={{
                        bgcolor: `${get(actionItem, "color", "#ccc")}26`,
                        color: get(actionItem, "color", "#666"),
                    }}
                />
            ),
            date: new Date(get(row, "date")).toISOString().replace('T', ' ').split('.')[0],
        };
    });

    return (
        <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
            <Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                    {__("labels.5")}
                </Typography>
                <IconButton
                    onClick={close}
                    sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Divider />
            <Table
                headTable={headTable}
                dataTable={dataTable}
                __={__}
                loading={get(log, "isLoading", false)}
                empty="tableDetalle"
                propsTable={{ size: "small" }}
            />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Dialog>
    );
};

export default LogsModal;
